//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

export enum SalesforceLocales {
  'CS_CZ' = 'cs_CZ',
  'DA_DK' = 'da_DK',
  'DE_DE' = 'de_DE',
  'EN_CA' = 'en_CA',
  'EN_EU' = 'en_EU',
  'EN_GB' = 'en_GB',
  'EN_US' = 'en_US',
  'ES_ES' = 'es_ES',
  'ES_MX' = 'es_MX',
  'ES_US' = 'es_US',
  'FI_FI' = 'fi_FI',
  'FR_CA' = 'fr_CA',
  'FR_FR' = 'fr_FR',
  'HU_HU' = 'hu_HU',
  'ID_ID' = 'id_ID',
  'IT_IT' = 'it_IT',
  'ET_EE' = 'et_EE',
  'JA_JP' = 'ja_JP',
  'KO_KR' = 'ko_KR',
  'LT_LT' = 'lt_LT',
  'LV_LV' = 'lv_LV',
  'NL_NL' = 'nl_NL',
  'PL_PL' = 'pl_PL',
  'PT_BR' = 'pt_BR',
  'RO_RO' = 'ro_RO',
  'RU_RU' = 'ru_RU',
  'SV_SE' = 'sv_SE',
  'TR_TR' = 'tr_TR',
  'ZH_CN' = 'zh_CN',
}
